import { Circle } from '@mui/icons-material';
import { Navigate, Outlet, useLocation } from 'react-router';
import { PAYMENTS_TABS, PRODUCT_REPORTS_TABS } from '../../../constants';
import { PAYMENTS_REPORTS_PATH, REPORTS_PATH, REPORTS_ROUTE } from '../../../constants/reports';
import { useMarketplace } from '../../../hooks/useMarketplace';
import TabNavigation from '../../organisms/TabNavigation';

const standaloneReportPaths = PAYMENTS_TABS.map((tab) => `${PAYMENTS_REPORTS_PATH}/${tab.value}`);

const ProductReportsLayout = () => {
  const { config, isStandaloneCasino, isLoading } = useMarketplace();
  const { pathname } = useLocation();

  if (!config && isLoading) return null;

  if (isStandaloneCasino) {
    if (config?.marketplaceConfig?.products?.casino !== true) {
      return <Navigate to='/' replace />;
    }

    const path = pathname.replace(/\/$/, '');
    if (path === REPORTS_PATH) {
      return <Navigate to={standaloneReportPaths[0]} replace />;
    }

    if (path !== PAYMENTS_REPORTS_PATH && !standaloneReportPaths.includes(path)) {
      return <Navigate to='/' replace />;
    }

    return <Outlet />;
  }

  return <TabNavigation basePath={REPORTS_ROUTE} tabs={PRODUCT_REPORTS_TABS} icon={<Circle fontSize='inherit' />} />;
};

export default ProductReportsLayout;
